import { getConfig } from "tbme/clientAdapter";
import { currentUser } from "tbme/localState";

/**
 * True when the profile viewer appears signed in for TBME bootstrap:
 * uses `currentUser().id` when set (legacy Visualforce), else TBME access token (e.g. digital-profile chassis).
 */
export function isProfileViewerAuthenticated(): boolean {
  const id = currentUser()?.id?.trim() ?? "";
  const token = getConfig().accessToken?.trim() ?? "";
  return Boolean(id || token);
}
